import React, { useState } from 'react';
import { Button, useTranslate, useRefresh } from 'react-admin';
import PlotEvidenceForm from './form';
import { Add as IconContentAdd, Close as CloseIcon } from '@material-ui/icons';
import { Dialog, DialogTitle, Grid, IconButton } from '@material-ui/core';
import { linkButton } from 'styles';

const resource = 'plotEvidence';

const PlotEvidenceQuickCreateButton = ({ record, permissions }) => {
  const [showDialog, setShowDialog] = useState(false);
  const translate = useTranslate();
  const refresh = useRefresh();
  const buttonClasses = linkButton();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  return (
    <>
      <Button
        className={buttonClasses.root}
        onClick={handleClick}
        label="ra.action.create"
      >
        <IconContentAdd />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={`create ${resource}`}
      >
        <DialogTitle>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            {translate(`resources.${resource}.titles.create`)}
            <IconButton aria-label="close" onClick={handleCloseClick}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <PlotEvidenceForm
          createRecord={{ plotId: record.id }}
          record={{}}
          resource={resource}
          onSuccess={(_) => {
            setShowDialog(false);
            // show created records in list
            refresh();
          }}
          permissions={permissions}
        />
      </Dialog>
    </>
  );
};

export default PlotEvidenceQuickCreateButton;
